// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__2t311","card":"Wrapper_card__1nqbT","loaderBlock":"Wrapper_loaderBlock__1c5_W","noData":"Wrapper_noData__3R5sH","sourceList":"Wrapper_sourceList__EQOMI"};